import { InjectDataSource, InjectRepository } from "@nestjs/typeorm";
import { ColumnReq, ColumnResponseModel, ColumnModel, ColumnActivateReq, CommonResponseModel } from "@project-management-system/shared-models";
import {  HsnCodeRepository } from "./hsn-code.repo";
import { Injectable } from "@nestjs/common";
import { DataSource } from "typeorm";



@Injectable()
export class HsnCodeService {
    constructor(
        private repo : HsnCodeRepository,
        @InjectDataSource()
        private dataSource: DataSource,
    ) { }


    async getAllHsnCode(): Promise<CommonResponseModel> {
        try {
          const data = await this.repo.find({order:{ hsncode: "ASC"}})
          if(data.length > 0){
            return new CommonResponseModel(true, 1, 'Data retrieved successfully', data)
          }else{
            return new CommonResponseModel(false, 0, 'No data found',[])
          }
        } catch (err) {
          return err;
        }
      }  


  
}